/* Import Module */
import $ from "jquery";
import { anchor } from "../variables";

/* Define Script */
export const autoscroll = () => {
  const anchorId = `#${anchor}`;
  const speed = 600;
  if ($(anchorId).length) {
    // アンカー用IDが存在している場合
    const position = $(anchorId).offset().top;
    $("html,body").animate({ scrollTop: position }, speed);
  } else {
    // アンカー用IDが存在しない場合、一番上にする
    $("body,html").animate({ scrollTop: 0 }, speed);
  }
};

/**
 * グローバル関数を定義
 */
(window as any).autoscroll = autoscroll;
